import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".modal__overlay {\n  position: fixed;\n  top: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--phx-modalBackgroundColor, #000);\n  opacity: var(--phx-modalOpacity, 0.8);\n}\n\n[dir=ltr] .modal__overlay {\n  left: 0;\n}\n\n[dir=rtl] .modal__overlay {\n  right: 0;\n}\n\n.modal__wrapper {\n  position: fixed;\n  top: 0;\n  z-index: 1050;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n[dir=ltr] .modal__wrapper {\n  left: 0;\n}\n\n[dir=rtl] .modal__wrapper {\n  right: 0;\n}\n\n.modal__container {\n  z-index: 100;\n  background: var(--phx-modalBackgroundContainer, #fff);\n  position: relative;\n  margin: auto;\n  top: 50%;\n  transform: translateY(-50%);\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  overflow-y: auto;\n  max-height: var(--phx-modalMaxHeight, calc(100% - 64px));\n  border-radius: var(--phx-modalBorderRadius, 8px);\n}\n\n.modal__content {\n  padding: 40px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1vZGFsLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxlQUFlO0VBQ2YsTUFBTTtFQUVOLGFBQWE7RUFDYixZQUFZO0VBQ1osYUFBYTtFQUNiLHVEQUF1RDtFQUN2RCxxQ0FBcUM7QUFDdkM7O0FBVEE7RUFHRSxPQUFPO0FBTVQ7O0FBVEE7RUFHRSxRQUFPO0FBTVQ7O0FBQ0E7RUFDRSxlQUFlO0VBQ2YsTUFBTTtFQUVOLGFBQWE7RUFDYixXQUFXO0VBQ1gsWUFBWTtFQUNaLGdCQUFnQjtFQUNoQixVQUFVO0FBQ1o7O0FBVEE7RUFHRSxPQUFPO0FBTVQ7O0FBVEE7RUFHRSxRQUFPO0FBTVQ7O0FBQ0E7RUFDRSxZQUFZO0VBQ1oscURBQXFEO0VBQ3JELGtCQUFrQjtFQUNsQixZQUFZO0VBQ1osUUFBUTtFQUNSLDJCQUEyQjtFQUMzQiwwQkFBa0I7RUFBbEIsdUJBQWtCO0VBQWxCLGtCQUFrQjtFQUNsQixnQkFBZ0I7RUFDaEIsd0RBQXdEO0VBQ3hELGdEQUFnRDtBQUNsRDs7QUFDQTtFQUNFLGFBQWE7QUFDZiIsImZpbGUiOiJtb2RhbC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm1vZGFsX19vdmVybGF5IHtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHotaW5kZXg6IDEwNDA7XG4gIHdpZHRoOiAxMDB2dztcbiAgaGVpZ2h0OiAxMDB2aDtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tcGh4LW1vZGFsQmFja2dyb3VuZENvbG9yLCAjMDAwKTtcbiAgb3BhY2l0eTogdmFyKC0tcGh4LW1vZGFsT3BhY2l0eSwgMC44KTtcbn1cbi5tb2RhbF9fd3JhcHBlciB7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICB6LWluZGV4OiAxMDUwO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBvdXRsaW5lOiAwO1xufVxuLm1vZGFsX19jb250YWluZXIge1xuICB6LWluZGV4OiAxMDA7XG4gIGJhY2tncm91bmQ6IHZhcigtLXBoeC1tb2RhbEJhY2tncm91bmRDb250YWluZXIsICNmZmYpO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG1hcmdpbjogYXV0bztcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbiAgd2lkdGg6IGZpdC1jb250ZW50O1xuICBvdmVyZmxvdy15OiBhdXRvO1xuICBtYXgtaGVpZ2h0OiB2YXIoLS1waHgtbW9kYWxNYXhIZWlnaHQsIGNhbGMoMTAwJSAtIDY0cHgpKTtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tcGh4LW1vZGFsQm9yZGVyUmFkaXVzLCA4cHgpO1xufVxuLm1vZGFsX19jb250ZW50IHtcbiAgcGFkZGluZzogNDBweDtcbn0iXX0= */";
styleInject(css_248z);

const findFocusableElements = (modalRef) => modalRef.current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]');
const handleTabKey = (e, modalRef) => {
    if (e.key === 'Tab' && modalRef.current) {
        const focusableElements = findFocusableElements(modalRef);
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
        }
        else if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
        }
    }
};

const Modal = ({ isShowing, children, close, disableOnClickClose, className, ariaLabel, showOverlay = true, }) => {
    const modalRef = useRef(null);
    const handleEscape = useCallback((event) => {
        if (event.keyCode === 27 && close)
            close();
    }, [close]);
    useEffect(() => {
        if (isShowing && close) {
            document.addEventListener('keydown', handleEscape, false);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape, false);
            document.body.style.overflow = 'auto';
        };
    }, [close, isShowing, handleEscape]);
    return isShowing
        ? ReactDOM.createPortal(jsxs("div", Object.assign({ className: className }, { children: [showOverlay && jsx("div", { className: "modal__overlay" }), jsx("div", Object.assign({ className: "modal__wrapper", "aria-modal": true, "aria-hidden": true, tabIndex: -1, role: "dialog", onClick: !disableOnClickClose && close ? close : undefined, "data-testid": "modal-wrapper", onKeyDown: (e) => handleTabKey(e, modalRef), ref: modalRef, "aria-label": ariaLabel }, { children: jsx("div", Object.assign({ className: "modal__container", onClick: (e) => e.stopPropagation(), "aria-hidden": true }, { children: children })) }))] })), document.body)
        : null;
};

export { Modal };
